import i18n from "@/i18n";

export const selectContentTemplateFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        tdClass: "text-left",
        sortDirection: "desc"
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        sortable: true,
        tdClass: "text-left",
        sortDirection: "desc"
    }
];
